import { Action } from "../../../actions/actions";
import {GamesActionTypes} from "../actions/actionTypes";

export interface Denominations {
    country: string;
    denominations: number[];
}

export function denominations(state: Denominations[] = [], action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_DENOMINATIONS_SUCCESS:
            return action.payload.results;
        default:
            return state;
    }
}

export function denominationsLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case GamesActionTypes.GET_DENOMINATIONS:
            return true;
        case GamesActionTypes.GET_DENOMINATIONS_SUCCESS:
        case GamesActionTypes.GET_DENOMINATIONS_FAIL:
            return false;
        default:
            return state;
    }
}
